import PIEText from '@src/shared/components/PIEText';
import React, { ReactNode } from 'react';
import { NavLink } from 'react-router-dom';
import { globalStyles } from 'snacks-design-system';
interface componentProps {
  to: any;
  children: ReactNode;
  className: string;
  activeClassName: string;
  isActive?: any;
  external?: boolean;
}

const { xdsColorContainerDark } = globalStyles;

const MobileNavigationDrawerTextNavLink = ({
  className,
  activeClassName,
  isActive,
  to,
  external,
  children,
}: componentProps) => {
  return (
    <NavLink
      to={!external ? to : false}
      className={className}
      activeClassName={activeClassName}
      isActive={isActive}
      onClick={() => {
        if (external) {
          window.location = to;
        }
      }}
    >
      <PIEText
        size="var(--xds-font-size-16)"
        color={xdsColorContainerDark}
        text={children}
      />
    </NavLink>
  );
};

export default MobileNavigationDrawerTextNavLink;
